// service/CarritoTaller.js
import instance from "../apis/app";
import { errorDeApi } from "./client";

const ObtenerCarrito = async () => {
    try {
        const response = await instance.get('/carrito-taller');
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const ObtenerCarritoItems = async () =>{
    try {
        const response = await instance.get('/carrito-taller/items');
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
}

const AgregarItem = async (itemData) => {
    try {
        const response = await instance.post('/carrito-taller/item', itemData);
        return response.data;
    } catch (error) {
        // 🆕 Mejorar extracción del mensaje de error
        const mensaje = error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "No se pudo agregar al carrito";

        throw {
            message: mensaje,
            status: error.response?.status
        };
    }
};

const EliminarItem = async (index) => {
    try {
        const response = await instance.delete(`/carrito-taller/item/${index}`);
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const VaciarCarrito = async () => {
    try {
        const response = await instance.delete('/carrito-taller');
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const ExtenderTiempo = async () => {
    try {
        const response = await instance.patch('/carrito-taller/extender');
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

export default {
    ObtenerCarrito,
    ObtenerCarritoItems,
    AgregarItem,
    EliminarItem,
    VaciarCarrito,
    ExtenderTiempo,
};
